export type SpacesNavigationState = {
    spacesBackTo?: string;
    spacesBackLabel?: string;
    revealedAccessCode?: string;
};

type RouteLike = {
    pathname: string;
    search?: string;
};

function isSafeSpacesPath(value: unknown): value is string {
    return typeof value === "string" && /^\/spaces(?:\/|\?|$)/.test(value);
}

export function spacesCurrentPath(location: RouteLike) {
    return `${location.pathname}${location.search || ""}`;
}

export function spacesBackState(location: RouteLike, label: string): SpacesNavigationState {
    return {
        spacesBackTo: spacesCurrentPath(location),
        spacesBackLabel: label,
    };
}

export function readSpacesBackState(state: unknown, fallbackPath = "/spaces", fallbackLabel = "Spaces") {
    const routeState = state && typeof state === "object" ? state as SpacesNavigationState : {};
    return {
        path: isSafeSpacesPath(routeState.spacesBackTo) ? routeState.spacesBackTo : fallbackPath,
        label: typeof routeState.spacesBackLabel === "string" && routeState.spacesBackLabel.trim()
            ? routeState.spacesBackLabel
            : fallbackLabel,
    };
}

export function hasSpacesBackState(state: unknown) {
    const routeState = state && typeof state === "object" ? state as SpacesNavigationState : {};
    return isSafeSpacesPath(routeState.spacesBackTo);
}
